import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import MaterialTable from 'material-table';
import { IsEmpty } from '../../../common/checks';

import apiService from '../../../services.js/apiService';
import { updateModalContent, toggleModal } from '../../../actions/modal';

const ReviewsTable = ({ pageId, updateModalContent, toggleModal }) => {
  const history = useHistory();
  const tableRef = useRef(null);
  const columns = [
    {
      title:  'Image', field:  'image', width:  '5%',
      render: (review) => (
        <div
          style={{
            background:   `url(${review.image}) center center / cover no-repeat rgb(255, 255, 255)`,
            borderRadius: '5px',
            minWidth:     '50px',
            maxWidth:     '50px',
            height:       '50px',
            border:       '1px solid #CCC',
          }}
        />
      ),
    },
    { title: 'Id', field: 'id', filtering: false, width: '5%' },
    { title: 'Place Name', field: 'placeName', filtering: false, width: '5%' },
    { title: 'Is All Page Outlets', field: 'isAllPlaceOutlets', filtering: false, width: '10%' },
    { title: 'Rating', field: 'rating', filtering: false },
    { title: 'Status', field: 'status', filtering: false, width: '5%' },
    { title: 'Searchable Status', field: 'searchableStatus', filtering: false },
    {
      title:     'Title',
      field:     'title',
      filtering: false,
      render:    (review) => (!IsEmpty(review.title) ? review.title.replace(/(.{100})..+/, '$1…') : ''),
    },
    {
      title:  'Updated At',
      field:  'Updated At',
      width:  '15%',
      render: (review) => (review.updatedAt !== null ? `${moment(review.updatedAt).format('D MMM YYYY HH:mm')}` : '-'),
    },
    {
      title:  'Last Updated By',
      field:  'lastUpdatedBy',
      width:  '15%',
      render: (review) => (!IsEmpty(review.lastUpdatedBy) ? review.lastUpdatedBy : '-'),
    },
  ];

  const [pageSize, setPageSize] = useState(20);

  const handleDelete = (id) => {
    updateModalContent({
      title:        'Are you sure?',
      content:      'All data related to this post will be deleted!',
      actionButton: {
        actionText: 'Yes, Delete',
        actionType: 'danger',
        action:     async () => {
          const result = await apiService.deleteReview(id);
          if (result) {
            toast.success('Review has been deleted');
            tableRef.current.onQueryChange();
          }
        },
      },
      cancelText:       'No',
      closeAfterAction: true,
    });

    toggleModal();
  };

  return (
    <MaterialTable
      tableRef={tableRef}
      className="material-table"
      title=""
      columns={columns}
      onChangeRowsPerPage={(pageSize) => {
        setPageSize(pageSize);
      }}
      data={(query) => new Promise(async (resolve, reject) => {
        try {
          // default order
          const order = ['updatedAt', 'DESC'];
          const result = await apiService.getReviewsByParams({ ...query, pageNo: query.page, pageId, order });
          let { rows, totalCount } = result;
          let { page } = query;

          if (rows.length === 0) {
            page = 0;

            if (totalCount !== 0) {
              const resultFirstPage = await apiService.getReviewsByParams(
                { ...query, pageNo: query.page, page, pageId },
              );

              rows = resultFirstPage.rows;
            }
          }
          resolve({
            data: rows,
            page,
            totalCount,
          });
        } catch (err) {
          toast.error(err);
          console.error(err);
          resolve({
            data:       [],
            page:       0,
            totalCount: 0,
          });
        }
      })}
      actions={[
        {
          icon:    'edit',
          tooltip: 'Edit Review',
          onClick: (event, review) => {
            history.push({
              pathname: `/admin/page/${pageId}/review/${review.id}`,
              state:    {
                from: 'page-review-listing',
              },
            });
          },
        },
        {
          icon:    'delete',
          tooltip: 'Delete Review',
          onClick: (event, review) => {
            handleDelete(review.id);
          },
        },
      ]}
      options={{
        pageSize,
        actionsColumnIndex:  -1,
        emptyRowsWhenPaging: false,
        search:              false,
        sorting:             true,
      }}
    />
  );
};

ReviewsTable.propTypes = {
  pageId:             PropTypes.string.isRequired,
  updateModalContent: PropTypes.func.isRequired,
  toggleModal:        PropTypes.func.isRequired,
};

const mapActionToProps = {
  updateModalContent,
  toggleModal,
};

export default connect(null, mapActionToProps)(ReviewsTable);
